import React from "react";
import Auth from "../../containers/Auth/Auth";

const SignUp = () => {

  return <Auth />;
};

export default SignUp;
